import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useFormContext } from 'react-hook-form';
import Button from '@mui/material/Button';
import { ChangeEventHandler, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface InputProps extends OutlinedInputProps {
    name: string;
    accept?: string;
    filename?: string;
    flagContractFile?: boolean;
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

export function InputFile(props: InputProps) {
    const { t } = useTranslation();
    const { register, setValue } = useFormContext();
    const [fileName, setFileName] = useState<string>(props.filename);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
        } else {
            setFileName(props.filename);
        }

        setValue(props.name, file);
    };

    useEffect(() => {
        if (props.flagContractFile) {
            setFileName('');
        }
    }, [props.flagContractFile]);
    return (
        <>
            <Button
                component="label"
                role={undefined}
                variant="contained"
                sx={{
                    '&.MuiButton-contained': {
                        background: 'transparent !important',
                        padding: '0 !important',
                    },
                    '&.MuiButton-contained>span>svg': { fontSize: '43px !important' },
                }}
                tabIndex={-1}
                endIcon={<UploadFileIcon />}
            >
                {fileName || t('general.selecionarArquivo')}
                <OutlinedInput
                    inputProps={{ accept: props.accept }}
                    id={props.name}
                    sx={{ display: 'none' }}
                    type="file"
                    size="small"
                    {...register(props.name)}
                    {...props}
                    onChange={props.onChange ?? handleFileChange}
                />
            </Button>
        </>
    );
}
